import { render } from "./IconLogo.vue?vue&type=template&id=43053ab6"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/IconLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43053ab6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43053ab6', __exports__)) {
    api.reload('43053ab6', __exports__)
  }
  
  module.hot.accept("./IconLogo.vue?vue&type=template&id=43053ab6", () => {
    api.rerender('43053ab6', render)
  })

}


export default __exports__